module.exports = __webpack_public_path__ + "img/left.8880b425.png";